
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitoakkalkotcab() {



    const cardData =
    {
        keyword: ' Mumbai to Akkalkot Cab Fare',
        heading: 'Deva Cabs:  Mumbai to Akkalkot Cab Fare',
        headingDescription: 'Deva Cabs offers reliable, comfortable, and hassle-free cab services from Mumbai to Akkalkot at competitive fares. Whether you are traveling for pilgrimage, family visits, or business, our experienced drivers and well-maintained fleet ensure a safe and smooth ride. Akkalkot, renowned for the Swami Samarth Maharaj temple and its vibrant spiritual atmosphere, attracts many devotees and visitors. With transparent fare packages, flexible scheduling, and multiple vehicle options, Deva Cabs guarantees a convenient and economical journey from Mumbai to Akkalkot every time.',

        top: 'Top Places to Visit in Akkalkot with Deva Cabs',

"topPlaces": [
  {
    "title": "Akkalkot Swami Samarth Maharaj Temple",
    "location": "Akkalkot, Solapur, Maharashtra",
    "description": "The revered samadhi and temple of 19th‑century saint Swami Samarth, believed to be an incarnation of Lord Dattatreya. A major pilgrimage hub featuring the Vatavruksha (banyan tree) shrine where the saint taught. Vibrant festivals like Jayanti and Guru Purnima draw throngs of devotees seeking blessings, meditation, and spiritual solace."
  },
  {
    "title": "Shree Swami Samarth Samadhi Math",
    "location": "Akkalkot, Solapur, Maharashtra",
    "description": "The serene math encloses the disciple Cholappa’s residence where Swami Samarth spent much of his time. It houses the Silver Paduka (sandals) and sacred relics—offering a calming retreat for reflection and deep spiritual connection."
  },
  {
    "title": "Akkalkot Palace",
    "location": "Akkalkot, Solapur, Maharashtra",
    "description": "A royal heritage site once belonging to the Bhonsale dynasty. The palace features stately architecture, historic halls, and the Armory Museum showcasing royal artifacts—ideal for history enthusiasts exploring princely state legacies."
  },
  {
    "title": "Taramata Bagh Public Garden",
    "location": "Akkalkot, Solapur, Maharashtra",
    "description": "A lush public park with manicured lawns, walking paths, and playgrounds. Perfect for families and casual strollers seeking a peaceful outdoor setting amid colorful flower beds and tree-shaded benches."
  },
  {
    "title": "Bijapur Bes",
    "location": "Near Akkalkot, Solapur, Maharashtra",
    "description": "Historical ruins reminiscent of the Bijapur Sultanate, featuring mosques, tombs, and palatial structures. A lesser-known archaeological treasure offering a glimpse into Indo-Islamic architecture off the beaten path."
  },
  {
    "title": "Gowmukh Teerth",
    "location": "Akkalkot, Solapur, Maharashtra",
    "description": "A sacred spot shaped like a cow’s mouth (gou‑mukh), revered by pilgrims. It’s ideal for peaceful rituals, meditation, and capturing serene views with a devotional ambiance."
  },
  {
    "title": "Kurnur Dam",
    "location": "Kurnur, Akkalkot Taluka, Solapur, Maharashtra",
    "description": "An earth-fill dam on the Bori River providing irrigation and local water supply. The surrounding reservoir area makes a tranquil getaway for nature lovers, picnickers, and anglers."
  }
],



"services": [
    {
        "name": "Mumbai to Akkalkot Cab Fare",
        "description": "Get transparent and competitive Mumbai to Akkalkot cab fares with Deva Cabs. Our fare structure is designed to offer the best value without compromising on comfort and safety, making your journey affordable and hassle-free."
    },
    {
        "name": "Affordable Mumbai to Akkalkot Taxi",
        "description": "Travel affordably from Mumbai to Akkalkot with our budget-friendly taxi services. Choose from economy or standard vehicles and enjoy a smooth, cost-effective ride with professional drivers."
    },
    {
        "name": "Outstation Cab Fare Mumbai to Akkalkot",
        "description": "Planning an outstation trip to Akkalkot? Deva Cabs provides clear and affordable outstation cab fares from Mumbai with no hidden charges, ensuring a comfortable and safe travel experience."
    },
    {
        "name": "Book Mumbai to Akkalkot Cab",
        "description": "Booking your Mumbai to Akkalkot cab is quick and simple with our online platform. Select your preferred vehicle, check fare estimates, and confirm your ride instantly."
    },
    {
        "name": "One Way Cab Fare to Akkalkot from Mumbai",
        "description": "Looking for a one-way cab from Mumbai to Akkalkot? We offer fixed one-way fares with transparent pricing and excellent service, perfect for quick trips or business travel."
    },
    {
        "name": "Round Trip Cab Fare Mumbai to Akkalkot",
        "description": "Enjoy the convenience of a round trip cab from Mumbai to Akkalkot with affordable fare packages, experienced drivers, and comfortable vehicles."
    },
    {
        "name": "AC Cab Fare Mumbai to Akkalkot",
        "description": "Beat the heat with our air-conditioned cab services to Akkalkot from Mumbai, available at competitive fares. Travel comfortably in fully AC-equipped vehicles."
    },
    {
        "name": "Luxury Cab Fare Mumbai to Akkalkot",
        "description": "For premium travel, choose our luxury cab services from Mumbai to Akkalkot with exclusive fare options. Experience elegance and comfort on your journey."
    },
    {
        "name": "SUV Cab Fare to Akkalkot",
        "description": "Travel spaciously with our SUV cab fare options from Mumbai to Akkalkot. Perfect for families or groups needing extra room and luggage capacity."
    },
    {
        "name": "Chauffeur-Driven Taxi Mumbai to Akkalkot",
        "description": "Experience professionalism and comfort with our chauffeur-driven taxi service from Mumbai to Akkalkot, available at competitive fare rates."
    },
    {
        "name": "Economy Cab Fare Mumbai to Akkalkot",
        "description": "For budget-conscious travelers, our economy cab fare from Mumbai to Akkalkot provides reliable service without breaking the bank."
    },
    {
        "name": "Online Fare Calculator Mumbai to Akkalkot",
        "description": "Use our online fare calculator to get instant estimates for Mumbai to Akkalkot cab rides. Customize your trip and budget your travel expenses easily."
    },
    {
        "name": "Mumbai to Akkalkot Car Rental Fare",
        "description": "Looking for flexible car rental options from Mumbai to Akkalkot? Check out our affordable car rental fares tailored for daily or long-term use."
    },
    {
        "name": "Budget Cab Fare Mumbai to Akkalkot",
        "description": "Choose our budget cab services from Mumbai to Akkalkot for affordable fares, reliable vehicles, and quality service suited for all travelers."
    }
],

"tableData": [
    ["Mumbai to Akkalkot Cab Fare", "-Affordable Mumbai to Akkalkot Taxi"],
    ["Outstation Cab Fare Mumbai to Akkalkot", "-Book Mumbai to Akkalkot Cab"],
    ["One Way Cab Fare to Akkalkot from Mumbai", "-Round Trip Cab Fare Mumbai to Akkalkot"],
    ["AC Cab Fare Mumbai to Akkalkot", "-Luxury Cab Fare Mumbai to Akkalkot"],
    ["SUV Cab Fare to Akkalkot", "-Chauffeur-Driven Taxi Mumbai to Akkalkot"],
    ["Economy Cab Fare Mumbai to Akkalkot", "-Online Fare Calculator Mumbai to Akkalkot"],
    ["Mumbai to Akkalkot Car Rental Fare", "-Budget Cab Fare Mumbai to Akkalkot"]
],

whychoose: [
  {
    "WhyChooseheading": "Reliable and On-Time Pickup from Mumbai",
    "WhyChoosedescription": "Deva Cabs ensures timely pickups from anywhere in Mumbai for your trip to Akkalkot. Start your journey stress-free with punctual service you can count on."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles for Long-Distance Travel",
    "WhyChoosedescription": "Travel comfortably in our clean, air-conditioned cars with ample legroom and luggage space. Whether it’s a solo trip or family travel, enjoy a smooth ride to Akkalkot."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Route Knowledge",
    "WhyChoosedescription": "Our professional drivers know the best routes to Akkalkot, ensuring safe and efficient travel. Sit back and relax as they navigate traffic and road conditions."
  },
  {
    "WhyChooseheading": "Transparent and Fair Fare Structure",
    "WhyChoosedescription": "No hidden fees or surge pricing. Deva Cabs provides clear and upfront fare estimates for your Mumbai to Akkalkot trip, so you know exactly what you’re paying before you ride."
  },
  {
    "WhyChooseheading": "Available 24/7 for Your Convenience",
    "WhyChoosedescription": "Whether you need an early morning pickup or a late-night ride, Deva Cabs is available round the clock for Mumbai to Akkalkot travel. Book anytime via app, website, or phone."
  },
  {
    "WhyChooseheading": "Highest Safety Standards Ensured",
    "WhyChoosedescription": "Your safety matters. Our vehicles are equipped with GPS, regularly sanitized, and driven by trained professionals committed to responsible driving."
  },
  {
    "WhyChooseheading": "Fast and Simple Booking Process",
    "WhyChoosedescription": "Book your Mumbai to Akkalkot cab quickly with our easy-to-use app or website. Get instant confirmation and real-time driver tracking for peace of mind."
  },
  {
    "WhyChooseheading": "Custom Travel Plans for Every Need",
    "WhyChoosedescription": "Whether a one-way trip, round trip, or hourly rental, Deva Cabs offers flexible packages tailored to your Mumbai to Akkalkot travel requirements."
  }
]




















    }




const faqData = [
  {
    question: "What is the fare for a cab from Mumbai to Akkalkot?",
    answer: "The fare for a cab from Mumbai to Akkalkot depends on the type of vehicle you choose. You can check the estimated fare using our website or mobile app, or contact customer support for a detailed quote."
  },
  {
    question: "What vehicle options are available for the Mumbai to Akkalkot trip?",
    answer: "We offer a variety of vehicles including hatchbacks, sedans, SUVs, and premium cars to suit your travel preferences and group size."
  },
  {
    question: "How long does the journey from Mumbai to Akkalkot take?",
    answer: "The journey from Mumbai to Akkalkot typically takes around 7 to 9 hours, depending on the traffic and road conditions."
  },
  {
    question: "Are there any discounts or offers for the Mumbai to Akkalkot cab service?",
    answer: "We occasionally offer special discounts and offers. Check our website or mobile app for any ongoing promotions or seasonal discounts for the Mumbai to Akkalkot route."
  },
  {
    question: "Is there an option for a round trip from Mumbai to Akkalkot?",
    answer: "Yes, you can book a round trip for your journey to Akkalkot. We ensure timely pick-up and drop-off as per your preferred schedule."
  },
  {
    question: "What are the payment options for booking a Mumbai to Akkalkot cab?",
    answer: "We accept cash, credit/debit cards, UPI, and online payments through our mobile app or website for your Mumbai to Akkalkot ride."
  },
  {
    question: "Are the drivers for Mumbai to Akkalkot rides experienced?",
    answer: "Yes, all our drivers are experienced, verified, and familiar with the Mumbai to Akkalkot route to ensure a safe and smooth journey."
  },
  {
    question: "Can I pre-schedule my Mumbai to Akkalkot ride?",
    answer: "Yes, you can pre-schedule your ride from Mumbai to Akkalkot through our booking portal or app. Choose your preferred date and time for guaranteed pickup."
  }
];

const testimonialData = [
  {
    id: 1,
    name: 'Mr. Vinod Deshmukh',
    role: 'Frequent Traveler',
    review: 'I’ve traveled multiple times from Mumbai to Akkalkot with Deva Cabs. The fares are reasonable, and the journey is always comfortable and punctual.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 2,
    name: 'Ms. Snehal Joshi',
    role: 'Pilgrim',
    review: 'I took a trip to Akkalkot with Deva Cabs for a religious pilgrimage. The ride was very comfortable, and the driver ensured we had a safe journey. Highly recommended!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];



























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Akkalkot Cab Fare",
  "image": "https://devacab.com/assets/images/mumbai-to-akkalkot-cab.jpg", // Replace with actual image URL
  "description": "Affordable and transparent Mumbai to Akkalkot cab fare by Deva Cabs. Calculate your outstation taxi fare for one-way and round trips. Choose from economy, luxury, SUV, and AC cabs with professional chauffeur services.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4500", // Example fare, update as needed
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-akkalkot-cab-fare" // Replace with actual page URL
  }
};



    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Akkalkot Cab Fare | Affordable Taxi Fare Mumbai to Akkalkot | Deva Cabs</title>
  <meta
    name="description"
    content="Calculate affordable Mumbai to Akkalkot cab fare with Deva Cabs. Transparent pricing for one-way and round trip taxi services. Choose from economy, luxury, SUV, and AC cabs with professional chauffeurs."
  />
  <meta
    name="keywords"
    content="Mumbai to Akkalkot Cab Fare, Affordable Mumbai to Akkalkot taxi, Outstation cab fare Mumbai to Akkalkot, Book Mumbai to Akkalkot cab, One way cab fare to Akkalkot from Mumbai, Round trip cab fare Mumbai to Akkalkot, AC cab fare Mumbai to Akkalkot, Luxury cab fare Mumbai to Akkalkot, SUV cab fare to Akkalkot, Chauffeur-driven taxi Mumbai to Akkalkot, Economy cab fare Mumbai to Akkalkot, Online fare calculator Mumbai to Akkalkot, Mumbai to Akkalkot car rental fare, Budget cab fare Mumbai to Akkalkot"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/64.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitoakkalkotcab;